import Axios from 'axios';

export class BodyCardTypeCardNumber {
   public 'cardType': string;
   public 'cardNumber': string;

    constructor(partial?: Partial<BodyCardTypeCardNumber>) {
        
        Object.assign(this, partial);
    }
}

/**
* loginUser
*/
export class BodyEmailPasswordBannerSourceApplication {
   public 'email': string;
   public 'password': string;
   public 'banner': string;
   public 'sourceApplication': string;

    constructor(partial?: Partial<BodyEmailPasswordBannerSourceApplication>) {
        
        Object.assign(this, partial);
    }
}

export class BodyBanner {
   public 'banner': string;

    constructor(partial?: Partial<BodyBanner>) {
        
        Object.assign(this, partial);
    }
}

export class BodyPortalToken {
   public 'portalToken': string;

    constructor(partial?: Partial<BodyPortalToken>) {
        
        Object.assign(this, partial);
    }
}

export class BodyRefreshTokenBanner {
   public 'refreshToken': string;
   public 'banner': string;

    constructor(partial?: Partial<BodyRefreshTokenBanner>) {
        
        Object.assign(this, partial);
    }
}

export class BodyEmailPasswordNewPasswordBanner {
   public 'email': string;
   public 'password': string;
   public 'newPassword': string;
   public 'banner': string;

    constructor(partial?: Partial<BodyEmailPasswordNewPasswordBanner>) {
        
        Object.assign(this, partial);
    }
}

export class BodyEmailBanner {
   public 'email': string;
   public 'banner': string;

    constructor(partial?: Partial<BodyEmailBanner>) {
        
        Object.assign(this, partial);
    }
}

export class ClubCardUser {
   public 'firstName': string;
   public 'lastName': string;
   public 'email': string;
   public 'password': string;
   public 'securityQuestion': SecurityQuestion;
   public 'securityAnswer': string;
   public 'clubCard': string;
   public 'agreedToMarketing': boolean;
   public 'phone': string;
   public 'title': string;
   public 'banner': string;

    constructor(partial?: Partial<ClubCardUser>) {
        
        Object.assign(this, partial);
    }
}

export class ClubCardUserResponse {
   public 'token': string;
   public 'refresh': string;
   public 'status': string;
   public 'userId': string;

    constructor(partial?: Partial<ClubCardUserResponse>) {
        
        Object.assign(this, partial);
    }
}

export class EmailSearch {
   public 'email': string;
   public 'banner': string;

    constructor(partial?: Partial<EmailSearch>) {
        
        Object.assign(this, partial);
    }
}

export class EmailSearchResult {
   public 'status': EmailSearchResult.StatusEnum;
   public 'roles': string[];
   public 'firstName': string;
   public 'lastName': string;

    constructor(partial?: Partial<EmailSearchResult>) {
        
        Object.assign(this, partial);
    }
}

export namespace EmailSearchResult {
    export enum StatusEnum {
        REGISTERED = <any>'REGISTERED',
        PARTIAL_REGISTERED = <any>'PARTIAL_REGISTERED',
        NOT_REGISTERED = <any>'NOT_REGISTERED'
    }
}

export class HybrisUser {
   public 'bannerID': string;
   public 'customerID': string;
   public 'firstName': string;
   public 'lastName': string;
   public 'dateOfBirth': string;
   public 'emailAddress': string;
   public 'phoneNumbers': HybrisuserPhoneNumbers[];
   public 'roles': HybrisuserRoles[];

    constructor(partial?: Partial<HybrisUser>) {
        
        Object.assign(this, partial);
    }
}

export class HybrisuserPhoneNumbers {
   public 'phoneNumber': string;
   public 'phoneNumberKind': string;

    constructor(partial?: Partial<HybrisuserPhoneNumbers>) {
        
        Object.assign(this, partial);
    }
}

export class HybrisuserRoles {
   public 'roleID': string;

    constructor(partial?: Partial<HybrisuserRoles>) {
        
        Object.assign(this, partial);
    }
}

export class InlineCodeMessage {
   public 'code': string;
   public 'message': string;

    constructor(partial?: Partial<InlineCodeMessage>) {
        
        Object.assign(this, partial);
    }
}

export class InlineError {
   public 'error': string;

    constructor(partial?: Partial<InlineError>) {
        
        Object.assign(this, partial);
    }
}

export class Search {
   public 'email': string;
   public 'clubCard': string;
   public 'name': string;
   public 'banner': string;

    constructor(partial?: Partial<Search>) {
        
        Object.assign(this, partial);
    }
}

export class SearchResult {
   public 'status': SearchResult.StatusEnum;
   public 'fistName': string;
   public 'lastName': string;
   public 'phoneNumber': string;
   public 'requireTitle': boolean;

    constructor(partial?: Partial<SearchResult>) {
        
        Object.assign(this, partial);
    }
}

export namespace SearchResult {
    export enum StatusEnum {
        REGISTERED = <any>'REGISTERED',
        PARTIAL_REGISTERED = <any>'PARTIAL_REGISTERED',
        NOT_REGISTERED = <any>'NOT_REGISTERED'
    }
}

export class SecurityQuestion {
   public 'id': string;
   public 'text': string;

    constructor(partial?: Partial<SecurityQuestion>) {
        
        Object.assign(this, partial);
    }
}

export class SecurityQuestions {
   public 'securityQuestions': SecurityQuestion[];

    constructor(partial?: Partial<SecurityQuestions>) {
        
        Object.assign(this, partial);
    }
}

export class SetPasswordRequest {
   public 'userIdHash': string;
   public 'resetToken': string;
   public 'password': string;

    constructor(partial?: Partial<SetPasswordRequest>) {
        
        Object.assign(this, partial);
    }
}

export class SetPasswordResponse {
   public 'firstName': string;
   public 'lastName': string;
   public 'email': string;
   public 'banner': string;
   public 'loyaltyMember': boolean;
   public 'roles': string[];

    constructor(partial?: Partial<SetPasswordResponse>) {
        
        Object.assign(this, partial);
    }
}

export class Shopper {
   public 'id': string;
   public 'email': string;
   public 'firstName': string;
   public 'lastName': string;
   public 'phone': string;
   public 'allowSubstitutions': boolean;
   public 'password': string;
   public 'agreedToTermsAndConditions': boolean;
   public 'agreedToMarketing': boolean;
   public 'banner': string;

    constructor(partial?: Partial<Shopper>) {
        
        Object.assign(this, partial);
    }
}

export class SubscriptionRequest {
   public 'email': string;
   public 'banner': string;
   public 'firstName': string;
   public 'lastName': string;
   public 'preferredStoreId': number;

    constructor(partial?: Partial<SubscriptionRequest>) {
        
        Object.assign(this, partial);
    }
}

export class SubscriptionResponse {

    constructor(partial?: Partial<SubscriptionResponse>) {
        
        Object.assign(this, partial);
    }
}

export class UserAuth {
   public 'userId': string;
   public 'access_token': string;
   public 'token_type': string;
   public 'refresh_token': string;
   public 'expires_in': number;
   public 'scope': string;

    constructor(partial?: Partial<UserAuth>) {
        
        Object.assign(this, partial);
    }
}

export class UserRegisterResponse {
   public 'userId': string;
   public 'token': string;
   public 'refresh': string;
   public 'status': string;

    constructor(partial?: Partial<UserRegisterResponse>) {
        
        Object.assign(this, partial);
    }
}

export class Validate {
   public 'cardNumber': string;
   public 'email': string;
   public 'banner': string;

    constructor(partial?: Partial<Validate>) {
        
        Object.assign(this, partial);
    }
}

export class ValidateUser {
   public 'phoneNumber': string;
   public 'firstName': string;
   public 'lastName': string;
   public 'valid': boolean;
   public 'requireTitle': boolean;

    constructor(partial?: Partial<ValidateUser>) {
        
        Object.assign(this, partial);
    }
}

export class UserApiServiceClass {
    public servicePath: string = '';

    public basePath: string = '/user';

    public authToken: string;

    /**
    *
   */
    public addLoyaltyCard(body?: BodyCardTypeCardNumber,  authToken?: string): Promise<void> {
        const _localVarPath = this.servicePath+this.basePath+'/card';
        const _params: any = {};

        const _formParams: any = {};

        let _bodyData;

        _bodyData = body;

        return new Promise<void>((resolve, reject) => {
            Axios({
                method: 'PUT'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || this.authToken) ? {'Authorization': 'Bearer ' + (authToken || this.authToken)} : undefined
            }).then((response) => {
                resolve();
            }).catch((error) => {
                reject(error);
            });
        });
    }
    /**
    *
   */
    public changePassword(body?: BodyEmailPasswordNewPasswordBanner,  authToken?: string): Promise<any> {
        const _localVarPath = this.servicePath+this.basePath+'/password';
        const _params: any = {};

        const _formParams: any = {};

        let _bodyData;

        _bodyData = body;

        return new Promise<any>((resolve, reject) => {
            Axios({
                method: 'POST'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || this.authToken) ? {'Authorization': 'Bearer ' + (authToken || this.authToken)} : undefined
            }).then((response) => {
                resolve(<any>response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
    /**
    *
   */
    public completeRegistration(body?: ClubCardUser,  authToken?: string): Promise<ClubCardUserResponse> {
        const _localVarPath = this.servicePath+this.basePath+'/registration/complete';
        const _params: any = {};

        const _formParams: any = {};

        let _bodyData;

        _bodyData = body;

        return new Promise<ClubCardUserResponse>((resolve, reject) => {
            Axios({
                method: 'POST'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || this.authToken) ? {'Authorization': 'Bearer ' + (authToken || this.authToken)} : undefined
            }).then((response) => {
                resolve(<ClubCardUserResponse>response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
    /**
    *
   */
    public createSubscription(body?: SubscriptionRequest,  authToken?: string): Promise<SubscriptionResponse> {
        const _localVarPath = this.servicePath+this.basePath+'/subscription';
        const _params: any = {};

        const _formParams: any = {};

        let _bodyData;

        _bodyData = body;

        return new Promise<SubscriptionResponse>((resolve, reject) => {
            Axios({
                method: 'POST'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || this.authToken) ? {'Authorization': 'Bearer ' + (authToken || this.authToken)} : undefined
            }).then((response) => {
                resolve(<SubscriptionResponse>response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
    /**
    *
   */
    public findUser(body?: Search,  authToken?: string): Promise<SearchResult> {
        const _localVarPath = this.servicePath+this.basePath+'/search';
        const _params: any = {};

        const _formParams: any = {};

        let _bodyData;

        _bodyData = body;

        return new Promise<SearchResult>((resolve, reject) => {
            Axios({
                method: 'POST'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || this.authToken) ? {'Authorization': 'Bearer ' + (authToken || this.authToken)} : undefined
            }).then((response) => {
                resolve(<SearchResult>response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
    /**
    *
   */
    public findUserByEmail(body?: EmailSearch,  authToken?: string): Promise<EmailSearchResult> {
        const _localVarPath = this.servicePath+this.basePath+'/search/email';
        const _params: any = {};

        const _formParams: any = {};

        let _bodyData;

        _bodyData = body;

        return new Promise<EmailSearchResult>((resolve, reject) => {
            Axios({
                method: 'POST'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || this.authToken) ? {'Authorization': 'Bearer ' + (authToken || this.authToken)} : undefined
            }).then((response) => {
                resolve(<EmailSearchResult>response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
    /**
    *
   */
    public getProfile( authToken?: string): Promise<Shopper> {
        const _localVarPath = this.servicePath+this.basePath+'';
        const _params: any = {};

        const _formParams: any = {};

        let _bodyData;

        return new Promise<Shopper>((resolve, reject) => {
            Axios({
                method: 'GET'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || this.authToken) ? {'Authorization': 'Bearer ' + (authToken || this.authToken)} : undefined
            }).then((response) => {
                resolve(<Shopper>response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
    /**
    *
   */
    public getSecurityQuestions( authToken?: string): Promise<SecurityQuestions> {
        const _localVarPath = this.servicePath+this.basePath+'/security-questions/';
        const _params: any = {};

        const _formParams: any = {};

        let _bodyData;

        return new Promise<SecurityQuestions>((resolve, reject) => {
            Axios({
                method: 'GET'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || this.authToken) ? {'Authorization': 'Bearer ' + (authToken || this.authToken)} : undefined
            }).then((response) => {
                resolve(<SecurityQuestions>response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
    /**
    *
   */
    public login(body?: BodyEmailPasswordBannerSourceApplication,  authToken?: string): Promise<UserAuth> {
        const _localVarPath = this.servicePath+this.basePath+'/login';
        const _params: any = {};

        const _formParams: any = {};

        let _bodyData;

        _bodyData = body;

        return new Promise<UserAuth>((resolve, reject) => {
            Axios({
                method: 'POST'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || this.authToken) ? {'Authorization': 'Bearer ' + (authToken || this.authToken)} : undefined
            }).then((response) => {
                resolve(<UserAuth>response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
    /**
    *
   */
    public loginAsGuest(body?: BodyBanner,  authToken?: string): Promise<UserAuth> {
        const _localVarPath = this.servicePath+this.basePath+'/login/guest';
        const _params: any = {};

        const _formParams: any = {};

        let _bodyData;

        _bodyData = body;

        return new Promise<UserAuth>((resolve, reject) => {
            Axios({
                method: 'POST'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || this.authToken) ? {'Authorization': 'Bearer ' + (authToken || this.authToken)} : undefined
            }).then((response) => {
                resolve(<UserAuth>response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
    /**
    *
   */
    public loginByPortalToken(body?: BodyPortalToken,  authToken?: string): Promise<UserAuth> {
        const _localVarPath = this.servicePath+this.basePath+'/login/portal';
        const _params: any = {};

        const _formParams: any = {};

        let _bodyData;

        _bodyData = body;

        return new Promise<UserAuth>((resolve, reject) => {
            Axios({
                method: 'POST'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || this.authToken) ? {'Authorization': 'Bearer ' + (authToken || this.authToken)} : undefined
            }).then((response) => {
                resolve(<UserAuth>response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
    /**
    *
   */
    public loginByRefreshToken(body?: BodyRefreshTokenBanner,  authToken?: string): Promise<UserAuth> {
        const _localVarPath = this.servicePath+this.basePath+'/login/refresh';
        const _params: any = {};

        const _formParams: any = {};

        let _bodyData;

        _bodyData = body;

        return new Promise<UserAuth>((resolve, reject) => {
            Axios({
                method: 'POST'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || this.authToken) ? {'Authorization': 'Bearer ' + (authToken || this.authToken)} : undefined
            }).then((response) => {
                resolve(<UserAuth>response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
    /**
    *
   */
    public logout( authToken?: string): Promise<any> {
        const _localVarPath = this.servicePath+this.basePath+'/logout';
        const _params: any = {};

        const _formParams: any = {};

        let _bodyData;

        return new Promise<any>((resolve, reject) => {
            Axios({
                method: 'POST'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || this.authToken) ? {'Authorization': 'Bearer ' + (authToken || this.authToken)} : undefined
            }).then((response) => {
                resolve(<any>response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
    /**
    *
   */
    public registerUser(body?: Shopper,  authToken?: string): Promise<UserRegisterResponse> {
        const _localVarPath = this.servicePath+this.basePath+'';
        const _params: any = {};

        const _formParams: any = {};

        let _bodyData;

        _bodyData = body;

        return new Promise<UserRegisterResponse>((resolve, reject) => {
            Axios({
                method: 'POST'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || this.authToken) ? {'Authorization': 'Bearer ' + (authToken || this.authToken)} : undefined
            }).then((response) => {
                resolve(<UserRegisterResponse>response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
    /**
    *
   */
    public resetPassword(body?: BodyEmailBanner,  authToken?: string): Promise<void> {
        const _localVarPath = this.servicePath+this.basePath+'/password/reset';
        const _params: any = {};

        const _formParams: any = {};

        let _bodyData;

        _bodyData = body;

        return new Promise<void>((resolve, reject) => {
            Axios({
                method: 'POST'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || this.authToken) ? {'Authorization': 'Bearer ' + (authToken || this.authToken)} : undefined
            }).then((response) => {
                resolve();
            }).catch((error) => {
                reject(error);
            });
        });
    }
    /**
    *
   */
    public setPassword(body?: SetPasswordRequest,  authToken?: string): Promise<SetPasswordResponse> {
        const _localVarPath = this.servicePath+this.basePath+'/password/set';
        const _params: any = {};

        const _formParams: any = {};

        let _bodyData;

        _bodyData = body;

        return new Promise<SetPasswordResponse>((resolve, reject) => {
            Axios({
                method: 'POST'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || this.authToken) ? {'Authorization': 'Bearer ' + (authToken || this.authToken)} : undefined
            }).then((response) => {
                resolve(<SetPasswordResponse>response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
    /**
    *
   */
    public updateHybrisUser(body?: HybrisUser,  authToken?: string): Promise<HybrisUser> {
        const _localVarPath = this.servicePath+this.basePath+'/hybris';
        const _params: any = {};

        const _formParams: any = {};

        let _bodyData;

        _bodyData = body;

        return new Promise<HybrisUser>((resolve, reject) => {
            Axios({
                method: 'PUT'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || this.authToken) ? {'Authorization': 'Bearer ' + (authToken || this.authToken)} : undefined
            }).then((response) => {
                resolve(<HybrisUser>response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
    /**
    *
   */
    public validateUser(body?: Validate,  authToken?: string): Promise<ValidateUser> {
        const _localVarPath = this.servicePath+this.basePath+'/validate';
        const _params: any = {};

        const _formParams: any = {};

        let _bodyData;

        _bodyData = body;

        return new Promise<ValidateUser>((resolve, reject) => {
            Axios({
                method: 'POST'.toLowerCase(),
                url: _localVarPath,
                params: _params,
                data: _bodyData || (Object.keys(_formParams).length ? _formParams : undefined),
                headers: (authToken || this.authToken) ? {'Authorization': 'Bearer ' + (authToken || this.authToken)} : undefined
            }).then((response) => {
                resolve(<ValidateUser>response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
}

export const UserApiService = new UserApiServiceClass();



// WEBPACK FOOTER //
// ./src/services/generated/edge/user/index.ts